export default {"src":"/_next/static/media/CNHI.df0302b1.svg","height":18,"width":18};